/**
 * @description 评论保存接口
 * @author duanjun
 */

import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';
// import { commentSaveErrHandle } from '_aaaa/errorHandle';

import { CommentParentType, CommentType, CommentSubjectType } from '@umu/umu-types';

interface IInput {
    parent_type: CommentParentType;
    parent_id: number;
    comment_type: CommentType;
    comment: string;
    extend?: any;
    comment_parent_id?: number;
    show_parent_id?: number; // 显示的时候的parentId。需求有些地方需要拍平显示
    note_state?: number;
    question_id?: number; // 问题id，兼容APP老版本，新版本请使用subject_id和subject_type组合
    nick_name?: string; // （仅parent_type为4有效）用户昵称
    is_anonymous?: 0 | 1; // （仅parent_type为4有效）是否匿名
    subject_id?: number; // 主题id，类型对应的id，比如问题id，照片id和班级feed id
    subject_type?: CommentSubjectType; // 主题类型，0:问题类型 1:小节照片类型 2:班级feed类型
}

interface IOutput {
    comment_info: IComment;
}

export type IResponseData = IResponse<IOutput>;

export const saveComment = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(
        Api.SAVE_COMMENT,
        Object.assign(
            {
                show_parent_id: 0,
                comment_parent_id: 0,
            },
            data,
        ),
        { silent: true },
    ).then((res: IResponseData) => {
        if (res.error_code) {
            // commentSaveErrHandle(res.error_code);
        }
        return res;
    });
};
